import { organizationConstants as oc } from 'srcReact/OrganizationPage'
import { setCookie, objectMap, getCookie } from 'srcReact/helpers/utils'
import { isUserAuthorized } from 'srcReact/helpers/userHelper'
import { commonConstants } from 'srcReact/components'
import { commonFeedConstants } from 'srcReact/components/common2/FeedsTabContent/constants'
import { organizationSettingsConstants } from 'srcReact/OrganizationSettingsPage'
import { messengerConstants } from 'srcReact/MessengerPage'
import { appConstantSettings } from '../appConstantSettings'

const current_organization = isUserAuthorized() && JSON.parse(localStorage.getItem('current_organization'))
const organization_list = isUserAuthorized() && JSON.parse(localStorage.getItem('organization_list'))

const initialState = {
  ask_access_page: '',
  authorized: false,
  new_orga: {
    submitted: false,
    created: false,
    error: false
  },
  organization_list: {
    loaded: false,
    error: false,
    items: organization_list || []
  },
  workplace_list: {
    loaded: false,
    error: false,
    items: []
  },
  current_organization: {
    updating: false,
    loaded: current_organization ? true : false,
    error: false,
    info: current_organization || {},
    users: []
  },
  member_list: {
    loaded: false,
    error: false,
    members: [],
    loading: false,
    error_message: '',
    stats: {},
    no_result: false
  },
  notification_list: {
    notifications: [],
    notificationStat: null,
    last_visit: null,
    is_temporary_muted: 0,
    error: null,
    loading: false,
    setReadSuccess: false
  },
  header: {
    loading: false,
    organizationId: 0,
    loaded: false,
    error: null,
    messenger: null,
    notifications: null,
    sidebar: null,
    subscription: null,
    popup: null,
    user_properties: null,
    newsfeed: null,
    codeVersion: null
  }
}
export function organization(state = initialState, action) {
  switch (action.type) {
    // Accesses
    case oc.CAN_ACCESS_CREATE_PAGE_REQUEST:
    case oc.CAN_ACCESS_LIST_PAGE_REQUEST:
    case oc.CAN_ACCESS_INDEX_PAGE_REQUEST: {
      return {
        organization_list: { ...state.organization_list },
        current_organization: { ...state.current_organization },
        ask_access_page: true,
        authorized: false
      }
    }
    case oc.CAN_ACCESS_CREATE_PAGE_SUCCESS:
    case oc.CAN_ACCESS_LIST_PAGE_SUCCESS:
    case oc.CAN_ACCESS_INDEX_PAGE_SUCCESS:
      return {
        ...state,
        ask_access_page: false,
        authorized: true
      }
    case oc.CAN_ACCESS_CREATE_PAGE_FAILURE:
    case oc.CAN_ACCESS_LIST_PAGE_FAILURE:
    case oc.CAN_ACCESS_INDEX_PAGE_FAILURE: {
      return {
        organization_list: { ...state.organization_list },
        current_organization: { ...state.current_organization },
        ask_access_page: false,
        authorized: false
      }
    }

    // Current organization
    case oc.GET_ORGANIZATION_REQUEST: {
      return {
        ...state,
        current_organization: {
          ...state.current_organization,
          updating: true,
          loaded: false,
          error: false
        }
      }
    }
    case oc.GET_ORGANIZATION_SUCCESS:
    case oc.SET_CURRENT_ORGANIZATION_ID:
    case oc.SWITCH_ORGANIZATION_SUCCESS: {
      if (action.organization) {
        localStorage.setItem('current_organization', JSON.stringify(action.organization))
        setCookie('current_organization_id', action.organization.resourceKey, 365)
        if (action.organization.s3Url) {
          setCookie('s3Url', action.organization.s3Url, 365)
        }
      }
      return {
        ...state,
        current_organization: {
          ...state.current_organization,
          updating: false,
          loaded: true,
          error: false,
          info: action.organization
        }
      }
    }
    case oc.GET_ORGANIZATION_FAILURE:
      return {
        ...state,
        current_organization: { ...state.current_organization, updating: false, loaded: false, error: true }
      }

    // New orga
    case oc.CREATE_ORGA_REQUEST:
      return {
        ...state,
        new_orga: { submitted: true, created: false, error: '' }
      }
    case oc.CREATE_ORGA_SUCCESS:
      state.organization_list.items.push(action.response)
      localStorage.setItem('organization_list', JSON.stringify(state.organization_list.items))
      setCookie('organization_list', JSON.stringify(state.organization_list.items), 365)
      return {
        ...state,
        organization_list: {
          ...state.organization_list,
          items: state.organization_list.items
        },
        new_orga: { submitted: false, created: true, error: '' },
        workplace_list: initialState.workplace_list //clear workplace list state once new org is created
      }
    case oc.CREATE_ORGA_FAILURE:
      return {
        ...state,
        new_orga: { submitted: false, created: false, error: action.error }
      }

    // List of organizations
    case oc.LIST_ORGA_REQUEST:
      return {
        ...state,
        organization_list: {
          loaded: false,
          error: false,
          items: state.organization_list.items
        }
      }
    case oc.LIST_ORGA_SUCCESS:
      const orga_list = action.response.list
        ? objectMap(
            action.response.list,
            (orga) => {
              return {
                ...orga.info,
                ...orga.organizations_basicsettings,
                my_access: orga.organizations_my_access
              }
            },
            true
          )
        : []
      localStorage.setItem('organization_list', JSON.stringify(orga_list))
      return {
        ...state,
        organization_list: {
          loaded: true,
          error: false,
          items: orga_list
        }
      }
    case oc.LIST_ORGA_FAILURE:
      return {
        ...state,
        organization_list: {
          loaded: false,
          error: true,
          items: state.organization_list.items
        }
      }

    // List of orga's users
    case oc.GET_USERS_REQUEST:
      return { ...state }
    case oc.GET_USERS_SUCCESS: {
      return {
        ...state,
        current_organization: {
          ...state.current_organization,
          users: action.response.list ? objectMap(action.response.list, (user) => user, true) : []
        }
      }
    }
    case oc.GET_USERS_FAILURE:
      return { ...state }

    // List of orga's workplaces
    case oc.LIST_WORKPLACE_REQUEST:
      return {
        ...state,
        workplace_list: {
          loaded: false,
          error: false,
          items: []
        }
      }
    case oc.LIST_WORKPLACE_SUCCESS:
      return {
        ...state,
        workplace_list: {
          loaded: true,
          error: false,
          items: action.response.workplace_list
        }
      }
    case oc.LIST_WORKPLACE_FAILURE:
      return {
        ...state,
        workplace_list: {
          loaded: false,
          error: true,
          items: []
        }
      }

    // Delete organization
    case oc.DELETE_ORGA_REQUEST:
      return {
        ...state
      }
    case oc.DELETE_ORGA_SUCCESS:
      const newList = state.organization_list.items.filter((item) => item.id !== state.current_organization.info.id)
      localStorage.setItem('organization_list', JSON.stringify(newList))

      if (newList.length) {
        let newCurrentOrga = newList[0]
        state.current_organization.info = newCurrentOrga
        localStorage.setItem('current_organization', JSON.stringify(newCurrentOrga))
        setCookie('current_organization_id', newCurrentOrga.resourceKey, 365)
      } else {
        state.current_organization.info = {}
        setCookie('current_organization_id', '', -1)
        localStorage.removeItem('current_organization')
      }
      return {
        ...state,
        organization_list: {
          ...state.organization_list,
          items: newList
        }
      }
    case oc.DELETE_ORGA_FAILURE:
      return {
        ...state
      }
    //member directory
    case oc.GET_MEMBER_DIRECTORY_REQUEST:
      const { isPagination } = action.response
      return {
        ...state,
        member_list: {
          ...state.member_list,
          loaded: false,
          error: false,
          loading: true,
          error_message: '',
          members: isPagination ? [...state.member_list.members] : [],
          stats: isPagination ? { ...state.member_list.stats } : {},
          no_result: false
        }
      }
    case oc.GET_MEMBER_DIRECTORY_SUCCESS:
      if (action.response) {
        const { members, stats } = action.response
        return {
          ...state,
          member_list: {
            ...state.member_list,
            loaded: true,
            error: false,
            loading: false,
            error_message: '',
            members: members ? [...state.member_list.members, ...members] : [...state.member_list.members],
            stats: stats && { ...stats },
            no_result: members.length === 0
          }
        }
      } else {
        return { ...state }
      }
    case oc.GET_MEMBER_DIRECTORY_FAILURE:
      return {
        ...state,
        member_list: {
          ...state.member_list,
          loaded: true,
          error: true,
          loading: false,
          members: [],
          error_message: action.error[0],
          no_result: false
        }
      }

    case oc.GET_NOTIFICATIONS_REQUEST: {
      const { isPagination } = action
      return {
        ...state,
        notification_list: {
          ...state.notification_list,
          loading: true,
          error: null,
          notifications: isPagination ? [...state.notification_list.notifications] : [],
          notificationStat: isPagination ? { ...state.notification_list.notificationStat } : {}
        }
      }
    }
    case oc.GET_NOTIFICATIONS_SUCCESS: {
      const { isPagination, response } = action
      let updatedList = [...state.notification_list.notifications]
      if (response.notifications) {
        if (isPagination) {
          updatedList = [...state.notification_list.notifications, ...response.notifications]
        } else if (state.notification_list.notifications.length === 0) {
          updatedList = [...response.notifications]
        }
      }
      return {
        ...state,
        notification_list: {
          ...state.notification_list,
          loading: false,
          last_visit: response.last_visit,
          is_temporary_muted: response.is_temporary_muted,
          error: null,
          notifications: updatedList,
          notificationStat: response.stats ? { ...response.stats } : {}
        }
      }
    }
    case oc.GET_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        notification_list: {
          ...state.notification_list,
          loading: false,
          error: action.error
        }
      }

    case oc.MARK_NOTIFICATIONS_READ_REQUEST: {
      return {
        ...state,
        notification_list: {
          ...state.notification_list,
          setReadSuccess: false
        }
      }
    }
    case oc.MARK_NOTIFICATIONS_READ_SUCCESS: {
      const { organizationId, notificationId } = action
      let updatedNotifications = state.notification_list.notifications
      if (action.response) {
        if (notificationId === 0 && organizationId > 0) {
          updatedNotifications = updatedNotifications.map((n) => {
            if (n.is_read === 0) {
              n.is_read = 1
            }
            return n
          })
        }
      }
      return {
        ...state,
        notification_list: {
          ...state.notification_list,
          setReadSuccess: true,
          notifications: updatedNotifications
        }
      }
    }
    case oc.MARK_NOTIFICATIONS_READ_FAILURE:
      return {
        ...state,
        notification_list: {
          ...state.notification_list,
          setReadSuccess: false
        }
      }

    case oc.GET_HEADER_REQUEST: {
      return {
        ...state,
        header: {
          ...state.header,
          loading: true
        }
      }
    }
    case commonConstants.SET_POPUP_COOKIE_SUCCESS: {
      return {
        ...state,
        header: {
          ...state.header,
          popup: action.response
        }
      }
    }
    case oc.GET_HEADER_SUCCESS: {
      const { scope, response } = action
      localStorage.setItem('current_lang', response?.user_properties?.language)
      setCookie(appConstantSettings.LANG_COOKIE_NAME, response?.user_properties?.language, appConstantSettings.LANG_COOKIE_EXP_DAYS)
      return {
        ...state,
        header: {
          ...state.header,
          loading: false,
          loaded: true,
          error: null,
          messenger: response.messenger,
          notifications: response.notifications,
          sidebar: scope.includes('sidebar') ? response.sidebar : state.header.sidebar,
          subscription: scope.includes('subscription') ? response.subscription : state.header.subscription,
          popup: scope.includes('popup_display') ? response.popup : state.header.popup,
          user_properties: response.user_properties,
          organizationId: response.current_organization_id,
          newsfeed: response.newsfeed,
          codeVersion: response.code_version
        }
      }
    }

    case messengerConstants.HIDE_CONV_SUCCESS: {
      const updatedRecentConvos = state.header.messenger?.recent_conversations?.filter(
        (conv) => conv.id !== action.response.conversation.id
      )
      return {
        ...state,
        header: {
          ...state.header,
          messenger: {
            ...state.header.messenger,
            recent_conversations: updatedRecentConvos
          }
        }
      }
    }

    case commonConstants.CLOSE_CTA_SUCCESS: {
      const ctaCategory = action.response.cta_category
      const closedAt = ctaCategory.closed_at
      const displayedAt = ctaCategory.displayed_at

      return {
        ...state,
        header: {
          ...state.header,
          user_properties: {
            ...state.header.user_properties,
            profile_completion: {
              ...state.header.user_properties.profile_completion,
              last_closed_at: closedAt,
              last_displayed_at: displayedAt,
              myfeed_cta:
                ctaCategory.slug === 'myfeed_profile'
                  ? {
                      ...state.header.user_properties.profile_completion.myfeed_cta,
                      last_closed_at: closedAt,
                      last_displayed_at: displayedAt
                    }
                  : state.header.user_properties.profile_completion.myfeed_cta,
              profile_cta:
                ctaCategory.slug === 'profile_profile'
                  ? {
                      ...state.header.user_properties.profile_completion.profile_cta,
                      last_closed_at: closedAt,
                      last_displayed_at: displayedAt
                    }
                  : state.header.user_properties.profile_completion.profile_cta
            }
          }
        }
      }
    }
    case oc.GET_HEADER_FAILURE:
      return {
        ...state,
        header: {
          ...state.header,
          loading: false,
          subscription: action.error.includes('No subscription found for this organization')
            ? null
            : state.header.subscription,
          loaded: true,
          error: action.error
        }
      }

    case commonFeedConstants.UPDATE_TAG_COUNT: {
      return {
        ...state,
        header: {
          ...state.header,
          newsfeed: {
            ...state.header.newsfeed,
            background_message_posting_count: state.header.newsfeed?.background_message_posting_count + 1
          }
        }
      }
    }

    case oc.SET_NATIVE_CURRENT_ORGANIZATION:
      return {
        ...state,
        current_organization: {
          ...state.current_organization,
          info: {
            ...state.current_organization.info,
            ...action.currentOrganization,
            my_access: action.currentOrganization.organizations_my_access,
            my_rights: action.currentOrganization.workplaces_my_rights
          }
        }
      }
    case organizationSettingsConstants.EDIT_ORGANIZATION_INFO_SUCCESS: {
      const { info, organizations_basicsettings } = action.data
      const updatedOrgList = state.organization_list.items.map((org) => {
        if (org.id === info.id) {
          org.accronym = organizations_basicsettings.accronym
          org.color = organizations_basicsettings.color
          org.name = info.name
          return org
        }
        return org
      })
      return {
        ...state,
        organization_list: {
          ...state.organization_list,
          items: updatedOrgList
        },
        current_organization: {
          ...state.current_organization,
          info: {
            ...state.current_organization.info,
            accronym: organizations_basicsettings.accronym,
            color: organizations_basicsettings.color,
            name: info.name,
            picture: info.picture
          }
        }
      }
    }

    case oc.NOTIFICATION_TEMPORARY_MUTE_SUCCESS:
      return {
        ...state,
        notification_list: {
          ...state.notification_list,
          is_temporary_muted: 1
        }
      }
    case oc.NOTIFICATION_TEMPORARY_UNMUTE_SUCCESS:
      return {
        ...state,
        notification_list: {
          ...state.notification_list,
          is_temporary_muted: 0
        }
      }

    default:
      return state
  }
}
